import { useState } from "react"
import { Accordion, Badge, ListGroup } from "react-bootstrap"
import "./hotel-list.css"
import { AccordionEventKey } from "react-bootstrap/esm/AccordionContext"
import { Brand, Hotel } from "../../App"

type Props = {
  brands: Brand[]
  setActiveHotel: (brand: string, hotel?: Hotel) => void
}

export default function HotelList(props: Props) {
  const [activeBrand, setActiveBrand] = useState("")
  const [activeHotel, setActiveHotel] = useState("")

  const selectBrand = (brand: AccordionEventKey) => {
    // We clicked a brand; clear the active hotel
    let chosenBrand = ""
    if (Array.isArray(brand)) {
      if ((brand as string[]).length > 0) {
        chosenBrand = brand[0]
      }
    } else if (brand === null) {
      chosenBrand = ""
    } else {
      chosenBrand = brand as string
    }
    setActiveBrand(chosenBrand)
    setActiveHotel("")
    props.setActiveHotel(chosenBrand, undefined)
  }
  const selectHotel = (hotel: Hotel) => {
    // Set the active hotel
    setActiveHotel(hotel.hotel_reference_id)
    props.setActiveHotel(activeBrand, hotel)
  }

  return (
    <Accordion onSelect={(eventKey: AccordionEventKey) => { selectBrand(eventKey)}}>
      {
        props.brands.map((brand) => {
          return (
            <Accordion.Item key={brand.brand_code} eventKey={brand.brand_code} >
              <Accordion.Header>
                <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "stretch" }}>
                  <div className="fw-bold">{brand.brand_code}</div>
                  <div>
                    <Badge className="me-2" bg="success">{brand.hotels.filter((h) => h.visibility === "live").length}</Badge>
                    <Badge className="me-2" bg="primary">{brand.hotels.filter((h) => h.visibility === "preview").length}</Badge>
                    <Badge className="me-2" bg="secondary">{brand.hotels.filter((h) => h.visibility === "hidden" || h.visibility === "obsolete").length}</Badge>
                  </div>

                </div>
              </Accordion.Header>
              <Accordion.Body>
                <ListGroup>{
                  brand.hotels.map((hotel, idx) => {
                    return (
                      <ListGroup.Item
                        as="li"
                        className="d-flex justify-content-between align-items-start"
                        action
                        onClick={() => selectHotel(hotel)}
                        active={hotel.hotel_reference_id === activeHotel}
                        key={hotel.hotel_reference_id}
                      >
                        <div className="ms-2 me-auto">
                          <div className="fw-bold">{hotel.name}</div>
                          {hotel.hotel_reference_id} ({hotel.visibility})
                        </div>
                      </ListGroup.Item>
                    )
                  })
                }
                </ListGroup>
              </Accordion.Body>
            </Accordion.Item>
          )
        })
      }
    </Accordion>
  )
}
